var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.64 0 6.88.16.16 3.36 3.04.16-.16 3.04-3.04.16.16 3.36 3.04.16.16 10.08 3.36.16.16 3.36 3.36.16.16 3.36 3.36.16.16 3.04 3.04-.16.16-6.56 3.36.16L47.84 48l-17.12-.16-.16-17.12-3.04-.16-.16-3.04-6.88.16-.16 3.04-3.04.16L17.12 48 0 47.84.16 24l3.36.16.16 6.56 3.04-.16.16-3.04 3.36-.16.16-3.36 3.36-.16.16-3.36 3.36-.16.16-10.08 3.04-.16-.16-3.36-3.04-.16.16-3.04 3.04-.16.16-3.36ZM6.88 36.16l3.36.16-.16 3.04-3.36-.16.16-3.04Zm31.04 0 3.36.16-.16 3.04-3.36-.16.16-3.04Z",
    fillRule: "evenodd",
    fill: "currentColor"
  }))));
};
export default SvgLogo;